export default __webpack_public_path__ + "static/media/ic_partners.9baadab0.svg";